var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 20,
    viewBox: "0 0 20 20",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(2 1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.65,
    cy: 7.65,
    fillRule: "nonzero",
    r: 6.15,
    stroke: "#c8c8c8",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.80017857 12.9501786h7.20000003v2.7h-7.20000003z",
    fill: "#c8c8c8",
    transform: "matrix(.70710678 .70710678 -.70710678 .70710678 14.036575 -5.286932)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.1c1930fa331163f64d7b30d2628af272.svg";
export { ForwardRef as ReactComponent };